import { makeStyles, Typography } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import { FunctionComponent } from "react";
import { ResourceCustomTheme } from "styles/config";
import { renderedTextEditorStyling } from "styles/legacy/utils";
import { sanitizeHtml } from "utils";

const useStyles = makeStyles((theme: ResourceCustomTheme) => ({
  container: {
    "& a": {
      textDecoration: "underline",
    },
    ...theme.mixins.moduleStyles(theme),
    "& > h4": {
      marginTop: 0,
    },
    "& > h3": {
      marginTop: 0,
    },
  },
  placeholdersBody: renderedTextEditorStyling(theme, "body"),
  placeholdersHeader: renderedTextEditorStyling(theme, "header"),
}));

type RichTextProps = {
  rawHtml?: string;
  header?: string;
  headerTag?: Variant;
};

const RichText: FunctionComponent<RichTextProps> = ({
  header,
  rawHtml,
  headerTag = "h4",
}) => {
  const styles = useStyles();

  if (!rawHtml && !header) {
    return null;
  }

  return (
    <div className={styles.container}>
      {header && (
        <Typography
          className={styles.placeholdersHeader}
          variant={headerTag}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(header) }}
        />
      )}
      {rawHtml && (
        <div
          className={styles.placeholdersBody}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(rawHtml),
          }}
        />
      )}
    </div>
  );
};

export default RichText;
